import {ChronoCodeScenario} from '../../../../allkeyme/core/parameters/ChronoCodeScenario';
import {FreeDataScenario} from '../../../../allkeyme/core/parameters/FreeDataScenario';
import {VisionScenario} from '../../../../allkeyme/vision/parameters/VisionScenario';

export class EngineScenario {
chronocode: ChronoCodeScenario;
freeData: FreeDataScenario;
kind: string;
vision: VisionScenario;
}

